import request from './request'

/**
 * 获取全部客户列表（不分页，用于下拉选择）
 */
export function getCustomerAll() {
  return request.post('/customer/page', { page: 1, size: 9999 })
}

/**
 * 创建客户
 * @param {object} data - 创建客户请求
 * @param {string} data.name - 客户姓名
 * @param {number} [data.gender] - 性别: 0-男, 1-女, 2-未知
 * @param {string} data.phone - 手机号码
 * @param {string} [data.telPhone] - 联系电话
 * @param {string} [data.email] - 邮箱
 * @param {string} [data.idCard] - 身份证号
 * @param {string} [data.source] - 客户来源
 * @param {number} [data.referrerId] - 引入人ID
 * @param {number} [data.level] - 客户等级: 0-普通, 1-重要, 2-VIP
 * @param {number} [data.status] - 客户状态: 0-潜在, 1-跟进中, 2-正式, 3-已流失
 * @param {string} [data.address] - 地址
 * @param {string} [data.detailAddress] - 详细地址
 * @param {string} [data.remark] - 备注
 */
export function createCustomer(data) {
  return request.post('/customer', data)
}

/**
 * 更新客户
 * @param {object} data - 更新客户请求
 * @param {number} data.id - 客户ID
 * @param {string} data.name - 客户姓名
 * @param {number} [data.gender] - 性别: 0-男, 1-女, 2-未知
 * @param {string} data.phone - 手机号码
 * @param {string} [data.telPhone] - 联系电话
 * @param {string} [data.email] - 邮箱
 * @param {string} [data.idCard] - 身份证号
 * @param {string} [data.source] - 客户来源
 * @param {number} [data.referrerId] - 引入人ID
 * @param {number} [data.level] - 客户等级: 0-普通, 1-重要, 2-VIP
 * @param {number} [data.status] - 客户状态: 0-潜在, 1-跟进中, 2-正式, 3-已流失
 * @param {string} [data.address] - 地址
 * @param {string} [data.detailAddress] - 详细地址
 * @param {string} [data.remark] - 备注
 */
export function updateCustomer(data) {
  return request.put('/customer', data)
}

/**
 * 为客户绑定引入人
 * @param {number} id - 客户ID
 * @param {object} data - 绑定请求
 * @param {number} data.customerId - 客户ID
 * @param {number} data.referrerId - 引入人ID
 */
export function bindCustomerReferrer(id, data) {
  return request.put(`/customer/${id}/referrer`, data)
}

/**
 * 获取客户详情
 * @param {number} id - 客户ID
 */
export function getCustomer(id) {
  return request.get(`/customer/${id}`)
}

/**
 * 分页查询客户列表
 * @param {object} data - 查询参数
 * @param {number} [data.id] - 客户ID
 * @param {string} [data.keyword] - 关键字（客户名称/手机号/企业名称）
 * @param {number} [data.referrerId] - 引入人ID
 * @param {number} [data.level] - 客户等级
 * @param {number} [data.status] - 客户状态
 * @param {number} [data.ownerUserId] - 所属人ID
 * @param {number} [data.ownerDeptId] - 所属部门ID
 * @param {number} [data.page] - 当前页
 * @param {number} [data.size] - 每页大小
 */
export function getCustomerPage(data) {
  return request.post('/customer/page', data)
}

/**
 * 创建企业
 * @param {object} data - 创建企业请求
 * @param {number} data.customerId - 客户ID
 * @param {string} data.companyName - 公司名称
 * @param {string} [data.socialCreditCode] - 统一社会信用代码
 * @param {string} [data.legalPerson] - 法定代表人
 * @param {string} [data.registeredCapital] - 注册资本
 * @param {string} [data.establishmentDate] - 成立日期
 * @param {string} [data.registeredAddress] - 注册地址
 * @param {string} [data.businessScope] - 经营范围
 * @param {string} [data.licenseUrl] - 营业执照图片存储key
 * @param {string} [data.remark] - 备注
 */
export function createCompany(data) {
  return request.post('/customer/company', data)
}

/**
 * 更新企业信息
 * @param {object} data - 更新企业请求
 * @param {number} data.id - 企业ID
 * @param {number} data.customerId - 客户ID
 * @param {string} data.companyName - 公司名称
 * @param {string} [data.socialCreditCode] - 统一社会信用代码
 * @param {string} [data.legalPerson] - 法定代表人
 * @param {string} [data.registeredCapital] - 注册资本
 * @param {string} [data.establishmentDate] - 成立日期
 * @param {string} [data.registeredAddress] - 注册地址
 * @param {string} [data.businessScope] - 经营范围
 * @param {string} [data.licenseUrl] - 营业执照图片存储key
 * @param {string} [data.remark] - 备注
 */
export function updateCompany(data) {
  return request.put('/customer/company', data)
}

/**
 * 识别营业执照
 * @param {object} data - 识别请求
 * @param {string} data.imageUrl - 营业执照图片URL
 */
export function recognizeCompanyLicense(data) {
  return request.post('/customer/company/license/ocr', data)
}

/**
 * 分页查询企业列表
 * @param {object} data - 查询参数
 * @param {number} [data.id] - 企业ID
 * @param {number} [data.customerId] - 客户ID
 * @param {string} [data.companyName] - 公司名称
 * @param {string} [data.socialCreditCode] - 统一社会信用代码
 * @param {string} [data.legalPerson] - 法定代表人
 * @param {number} [data.page] - 当前页
 * @param {number} [data.size] - 每页大小
 */
export function getCompanyPage(data) {
  return request.post('/customer/company/page', data)
}

/**
 * 删除企业
 * @param {number} id - 企业ID
 */
export function deleteCompany(id) {
  return request.delete(`/customer/company/${id}`)
}

/**
 * 添加客户跟进记录
 * @param {object} data - 创建客户跟进记录请求
 * @param {number} data.customerId - 客户ID
 * @param {number} data.followType - 跟进方式
 * @param {string} data.followContent - 跟进内容
 * @param {string} [data.followTime] - 跟进时间
 * @param {string} [data.nextFollowTime] - 下次跟进时间
 * @param {string} [data.remark] - 备注
 */
export function createCustomerFollow(data) {
  return request.post('/customer/follow', data)
}

/**
 * 更新跟进记录
 * @param {object} data - 更新客户跟进记录请求
 * @param {number} data.id - 记录ID
 * @param {number} data.customerId - 客户ID
 * @param {number} data.followType - 跟进方式
 * @param {string} data.followContent - 跟进内容
 * @param {string} [data.followTime] - 跟进时间
 * @param {string} [data.nextFollowTime] - 下次跟进时间
 * @param {string} [data.remark] - 备注
 */
export function updateCustomerFollow(data) {
  return request.put('/customer/follow', data)
}

/**
 * 分页查询客户跟进记录
 * @param {object} data - 查询参数
 * @param {number} [data.id] - 记录ID
 * @param {number} [data.customerId] - 客户ID
 * @param {number} [data.followType] - 跟进方式
 * @param {string} [data.followTimeStart] - 跟进开始时间
 * @param {string} [data.followTimeEnd] - 跟进结束时间
 * @param {number} [data.page] - 当前页
 * @param {number} [data.size] - 每页大小
 */
export function getCustomerFollowPage(data) {
  return request.post('/customer/follow/page', data)
}

/**
 * 删除跟进记录
 * @param {number} id - 记录ID
 */
export function deleteCustomerFollow(id) {
  return request.delete(`/customer/follow/${id}`)
}

/**
 * 获取资料类型配置（表单/文件）
 */
export function getCustomerMaterialTypes() {
  return request.get('/customer/material-types')
}

/**
 * 获取客户资料列表（按分类）
 * @param {number} customerId - 客户ID
 */
export function getCustomerMaterials(customerId) {
  return request.get(`/customer/${customerId}/materials`)
}

/**
 * 获取客户资料实例列表（平铺返回，不带分类树）
 * @param {number} customerId - 客户ID
 * @param {object} [params] - 查询参数
 */
export function listCustomerMaterialInstances(customerId, params) {
  return request.get(`/customer/${customerId}/materials/instances`, { params })
}

/**
 * 获取客户某类资料详情
 * @param {number} customerId - 客户ID
 * @param {string} definitionCode - 资料类型编码
 */
export function getCustomerMaterialDetail(customerId, definitionCode) {
  return request.get(`/customer/${customerId}/materials/${definitionCode}`)
}

/**
 * 根据ID获取资料详情
 * @param {number} id - 用户资料ID
 */
export function getCustomerMaterialDetailById(id) {
  return request.get(`/customer/materials/${id}`)
}

/**
 * 创建资料
 * @param {object} data - 创建资料请求
 * @param {number} data.customerId - 客户ID
 * @param {string} data.definitionCode - 资料类型编码
 * @param {string} [data.name] - 资料名称（默认使用资料定义名称）
 * @param {string} data.formData - 表单JSON字符串
 * @param {string} [data.expireDate] - 有效期(YYYY-MM-DD)
 * @param {Array} [data.files] - 复用文件列表
 */
export function createCustomerMaterial(data) {
  return request.post('/customer/materials', data)
}

/**
 * 更新资料
 * @param {object} data - 更新资料请求
 * @param {number} data.userMaterialId - 客户资料ID
 * @param {number} data.customerId - 客户ID
 * @param {string} data.definitionCode - 资料类型编码
 * @param {string} [data.name] - 资料名称
 * @param {string} data.formData - 表单JSON字符串
 * @param {string} [data.expireDate] - 有效期(YYYY-MM-DD)
 * @param {Array} [data.files] - 复用文件列表
 */
export function updateCustomerMaterial(data) {
  return request.put('/customer/materials', data)
}

/**
 * 更新资料是否对客户可见
 * @param {object} data - 更新参数，需带上资料原始关键字段避免覆盖
 * @param {number} data.userMaterialId - 客户资料ID
 * @param {number} data.customerId - 客户ID
 * @param {string} data.definitionCode - 资料类型编码
 * @param {string} [data.name] - 资料名称
 * @param {string} [data.formData] - 表单 JSON
 * @param {string} [data.expireDate] - 有效期
 * @param {boolean} data.visibleToCustomer - 是否对客户可见
 */
export function updateCustomerMaterialVisibility(data) {
  return request.put('/customer/materials', data)
}

/**
 * 统一提交资料（创建/更新+关联文件）
 * @param {object} data - 提交资料请求
 * @param {number} data.customerId - 客户ID
 * @param {string} data.definitionCode - 资料类型编码
 * @param {string} [data.name] - 资料名称（默认使用资料定义名称）
 * @param {string} data.formData - 表单JSON字符串
 * @param {string} [data.expireDate] - 有效期(YYYY-MM-DD)
 * @param {Array} [data.files] - 复用文件列表
 */
export function submitCustomerMaterial(data) {
  return request.post('/customer/materials/submit', data)
}

/**
 * 上传资料文件（追加版本）
 * @param {number} customerId - 客户ID
 * @param {number} userMaterialId - 用户资料ID
 * @param {FormData} data - 表单数据
 */
export function uploadCustomerMaterialFile(customerId, userMaterialId, data) {
  return request.post(`/customer/${customerId}/materials/${userMaterialId}/files`, data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

/**
 * 删除资料
 * @param {number} customerId - 客户ID
 * @param {number} userMaterialId - 用户资料ID
 */
export function deleteCustomerMaterial(customerId, userMaterialId) {
  return request.delete(`/customer/${customerId}/materials/${userMaterialId}`)
}

/**
 * 删除资料文件
 * @param {number} userMaterialId - 客户资料ID
 * @param {number} fileId - 文件ID
 */
export function deleteCustomerMaterialFile(userMaterialId, fileId) {
  return request.delete(`/customer/materials/${userMaterialId}/files/${fileId}`)
}

// ============== 资料分类管理 API ==============

/**
 * 获取资料分类列表
 */
export function getMaterialCategories() {
  return request.get('/customer/material-categories')
}

/**
 * 获取资料分类详情
 * @param {number} id - 分类ID
 */
export function getMaterialCategory(id) {
  return request.get(`/customer/material-categories/${id}`)
}

/**
 * 创建资料分类
 * @param {object} data - 创建资料分类请求
 * @param {string} data.code - 分类编码
 * @param {string} data.name - 分类名称
 * @param {number} [data.parentId] - 父分类ID
 * @param {number} [data.sort] - 排序
 * @param {string} [data.icon] - 分类图标
 * @param {string} [data.description] - 分类描述
 */
export function createMaterialCategory(data) {
  return request.post('/customer/material-categories', data)
}

/**
 * 更新资料分类
 * @param {number} id - 分类ID
 * @param {object} data - 更新资料分类请求
 * @param {string} [data.name] - 分类名称
 * @param {number} [data.sort] - 排序
 * @param {string} [data.icon] - 分类图标
 * @param {string} [data.description] - 分类描述
 */
export function updateMaterialCategory(id, data) {
  return request.put(`/customer/material-categories/${id}`, data)
}

/**
 * 删除资料分类
 * @param {number} id - 分类ID
 */
export function deleteMaterialCategory(id) {
  return request.delete(`/customer/material-categories/${id}`)
}

// ============== 资料类型管理 API ==============

/**
 * 分页查询资料类型列表
 * @param {object} params - 查询参数
 * @param {number} [params.page] - 当前页
 * @param {number} [params.size] - 每页大小
 * @param {number} [params.categoryId] - 分类ID
 * @param {string} [params.keyword] - 关键词搜索
 * @param {number} [params.status] - 状态
 */
export function getMaterialDefinitions(params) {
  return request.get('/customer/material-definitions', { params })
}

/**
 * 获取资料类型详情
 * @param {number} id - 资料类型ID
 */
export function getMaterialDefinition(id) {
  return request.get(`/customer/material-definitions/${id}`)
}

/**
 * 创建资料类型
 * @param {object} data - 创建资料类型请求
 * @param {number} data.categoryId - 所属分类ID
 * @param {string} data.code - 资料类型编码
 * @param {string} data.name - 资料名称
 * @param {string} [data.nameAlias] - 别名
 * @param {string} [data.description] - 资料描述
 * @param {number} [data.isRequired] - 是否必填: 0-否, 1-是
 * @param {number} [data.allowMultiple] - 是否允许多个: 0-否, 1-是
 * @param {number} [data.maxVersions] - 最大版本数
 * @param {number} [data.needExpireCheck] - 是否检查有效期: 0-否, 1-是
 * @param {number} [data.expireMonths] - 有效期月数
 * @param {number} [data.sort] - 排序
 * @param {number} [data.uploadOnly] - 是否只需上传文件: 0-否, 1-是
 * @param {object} [data.fileConfig] - 文件上传配置
 * @param {object} [data.formSchema] - 表单JSON Schema
 */
export function createMaterialDefinition(data) {
  return request.post('/customer/material-definitions', data)
}

/**
 * 更新资料类型
 * @param {number} id - 资料类型ID
 * @param {object} data - 更新资料类型请求
 * @param {string} [data.name] - 资料名称
 * @param {string} [data.nameAlias] - 别名
 * @param {string} [data.description] - 资料描述
 * @param {number} [data.isRequired] - 是否必填: 0-否, 1-是
 * @param {number} [data.allowMultiple] - 是否允许多个: 0-否, 1-是
 * @param {number} [data.maxVersions] - 最大版本数
 * @param {number} [data.needExpireCheck] - 是否检查有效期: 0-否, 1-是
 * @param {number} [data.expireMonths] - 有效期月数
 * @param {number} [data.sort] - 排序
 * @param {number} [data.status] - 状态: 0-禁用, 1-启用
 * @param {number} [data.uploadOnly] - 是否只需上传文件: 0-否, 1-是
 * @param {object} [data.fileConfig] - 文件上传配置
 * @param {object} [data.formSchema] - 表单JSON Schema
 */
export function updateMaterialDefinition(id, data) {
  return request.put(`/customer/material-definitions/${id}`, data)
}

/**
 * 删除资料类型
 * @param {number} id - 资料类型ID
 */
export function deleteMaterialDefinition(id) {
  return request.delete(`/customer/material-definitions/${id}`)
}
